<template>
  <div class="f-pl-8">
    <input
      type="checkbox"
      class="f-form-checkbox f-w-4 f-h-4 f-rounded f-border-gray-400 focus:f-ring-2 f-float-left f--ml-5"
      :id="id"
      :checked="value"
      :disabled="disabled"
      :name="name"
      :value="inputValue"
      v-bind="$attrs"
      @change="$emit('input', $event.target.checked)"
    />
    <div class="f--mt-1 f-ml-2">
      <label :for="id">
        <slot />
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseAlignTopCheckbox",

  props: {
    id: {
      type: String,
      default: function () {
        return "checkbox-id-" + this.uid;
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: function () {
        return "checkbox-name-" + this.uid;
      },
    },
    inputValue: {
      default: true,
    },
  },
});
</script>
